"use client";
import { RiMoonLine, RiSunLine } from "react-icons/ri";
import { THEME_KEY } from "utils/helper/states";
import { selectTheme } from "store/theme/theme.selector";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "store/theme/theme.action";
import { classNames } from "utils/helper/helper";

const DarkModeToggle = () => {
  const theme = useSelector(selectTheme),
    dispatch = useDispatch(),
    switchTheme = () => {
      const mode = theme === "dark" ? "light" : "dark";
      dispatch(setTheme(mode));
      localStorage.setItem(THEME_KEY, mode);
    };
  return (
    <button
      onClick={switchTheme}
      className={classNames(
        "dark:bg-orange-500 group flex h-10 w-10 items-center",
        "justify-center rounded-full border border-marshland-100",
        "bg-white transition-colors hover:border-transparent",
        "hover:bg-orange-500 focus:border-transparent focus:bg-orange-500",
        "dark:border-transparent dark:bg-white/[.15] dark:hover:bg-orange-500"
      )}>
      {theme === "light" ? <RiMoonLine /> : <RiSunLine />}
    </button>
  );
};

export default DarkModeToggle;
